
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.25 150.25"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"75.12","cy":"75.12","r":"75.12","fill":"#e6e6e6"}}),_c('polyline',{attrs:{"points":"112.72 52.13 112.72 118.06 53.6 118.06","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('polyline',{attrs:{"points":"44.83 118.06 37.53 118.06 37.53 42.88 105.58 42.88","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M70.61,29.48c2.61,2.61,5.18,14.65,5.18,14.65s-12-2.57-14.65-5.19a6.69,6.69,0,0,1,9.47-9.46Z","transform":"translate(-.67 -.67)","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M81,29.48c-2.62,2.61-5.18,14.65-5.18,14.65s12-2.57,14.64-5.19A6.69,6.69,0,0,0,81,29.48Z","transform":"translate(-.67 -.67)","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('line',{attrs:{"x1":"75.12","y1":"43.46","x2":"75.12","y2":"118.06","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('line',{attrs:{"x1":"37.53","y1":"80.76","x2":"112.72","y2":"80.76","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    